<template>
  <div>
    <v-skeleton-loader v-if="loading" type="article, list-item-three-line@9"></v-skeleton-loader>
    <div class="pl-2 pr-0 no-printme">

        <!--      Buttons    -->
      <v-row class="px-2 pt-2 pb-1 d-print-none" v-if="!showNoEligibleDocMessage">
        <v-btn-toggle
          v-if="policy && policy.pid"
          v-model="doc"
          class="viewpolicy-tabs"
          tile
          color='secondary darken-2'
          group
        >
          <v-btn value="Summary" v-if="showSummaryTab">
            Summary
          </v-btn>
          <v-btn value="Indicate" v-if="showIndicateTab"><!-- 13 Feb 2026 JCH: Separate Indicate tab from Quote tab -->
            Indicate
          </v-btn>
          <v-btn class="ml-2" value="QuoteWithNcd" v-if="showQuoteTab">QUOTE w/NCD</v-btn>
          <v-btn value="Quote" v-if="showQuoteTab">QUOTE</v-btn>
          <v-btn value="Request" v-if="showRequestTab">Request</v-btn>
          <v-btn value="Binder" v-if="showBinderTab">Binder</v-btn>
          <v-btn value="Declarations" v-if="showDeclarationsTab">Declarations</v-btn>
        </v-btn-toggle>
        <v-spacer/>
        <button-tip @click="printDiv()" color="secondary darken-2" text tile tip="Print Dialog" txt="Print" xlarge btnstyle="margin-top: 3px;"/>
      </v-row>

      <v-card id="printableArea" class="px-4 mx-auto elevation-4 oldStyles rounded-0 printme" width="985"><!-- 13 Feb 2026 JCH: removed old negative top-card offset -->
        <div v-if="showNoEligibleDocMessage" class="d-flex align-center justify-center text-center px-6" style="min-height: 68vh; font-size: 17px;">
          <v-icon color="warning" class="mr-2">mdi-alert-circle-outline</v-icon>
          <span>No document for this status. Update policy status to view Summary/Indicate/Quote/Request/Binder documents.</span>
        </div>
        <div v-else :class="isQuoteLikeDoc ? (isSummaryDoc ? 'div2 nonquote-screen-pad' : 'div2 quote-shell') : 'div2 non-quote-shell nonquote-screen-pad'"><!-- 13 Feb 2026 JCH: split quote vs non-quote shell -->
          <!-- 13 Feb 2026 JCH: Summary + Quote + Indicate -->
          <template v-if="isQuoteLikeDoc">
          <template v-if="isSummaryDoc">
            <div class="d-none d-print-block" style="height: 12px;"></div>
            <span class="my-3 quote summary-header">
              <div class="my-0 h6 text-center">{{ summaryTitle }}</div>
              <div class="my-0 h6 text-center"><em>offered by Dominion Insurance Services to</em></div>
              <div class="my-0 h4 text-center">{{ summaryFirmName }}</div>
            </span>
            <br>
            <table class="caption quotetable summarytable" style="text-align: right; width:100%">
              <colgroup>
                <col style="width: 62px">
                <col style="width: 15%">
                <col style="width: 12%">
                <col style="width: 12%"><!-- 18 Jul 2026 JCH (NC-1577): Expiry matches Incept/Retro width (was 8% for Term yrs) -->
                <col style="width: 12%">
                <col style="width: 17%">
                <col style="width: 12%">
                <col style="width: 12%">
                <col style="width: 62px">
              </colgroup>
              <tr>
                <th style="line-height: 1.1; width: 44px; text-align: center">Send<br>Firm<br>Quote</th>
                <th style="text-align: left">Carrier</th>
                <th class="date-col" style="text-align: center">Incept</th>
                <th class="date-col" style="text-align: center">Expiry</th>
                <th class="date-col" style="text-align: center">Retro</th>
                <th style="text-align: left">Limits of<br>Liability</th>
                <th>Deductible</th>
                <th>Total<br>Estimate</th>
                <th style="line-height: 1.1; width: 62px; text-align: center; white-space: nowrap; word-break: keep-all;">Send<br>Specimen<br>Policy</th>
              </tr>
              <tr :key="optionPolicy.pid || `summary-row-${index}`" v-for="(optionPolicy, index) in summaryTablePolicies">
                <td style="text-align: center"><span class="summary-check-box"></span></td>
                <td style="text-align: center">{{ optionPolicy.carrier || policy.carrier || '' }}</td>
                <td class="date-col" style="text-align: center">{{ optionPolicy.incept || policy.incept }}</td>
                <td class="date-col" style="text-align: center">{{ quoteExpiryDisplay(optionPolicy) }}</td>
                <td class="date-col" style="text-align: center">{{ date(optionPolicy.retro || policy.retro) }}</td>
                <td style="text-align: center">{{ optionPolicy.limits }}</td>
                <td style="padding-right: 12px;">{{ optionPolicy.deduc }}</td>
                <td style="padding-right: 14px;">{{ $_curFormat(optionPolicy.total) }}</td>
                <td style="text-align: center"><span class="summary-check-box"></span></td>
              </tr>
            </table>
            <br>
            <div class="fine_print">
              Applicant hereby requests that Dominion prepare a firm premium quotation detailing the policy features and binding
              subjectivities for each selected option above. Applicant acknowledges that options listed constitute preliminary
              premium indications and are subject to change after underwriting review. Unless otherwise stated, terms expire
              the earlier of 15 days from issuance or the first business day after expiration of the current policy. Binding is
              subject to required documentation and payment. Total estimate includes taxes and fees, if any.
            </div>
            <div class="quote-signature-block">
              <div class="quote-signature-row">
                <span>Signature:</span><span class="sig-line sig-line-wide"></span>
                <span>Title:</span><span class="sig-line"></span>
                <span>Date:</span><span class="sig-line"></span>
              </div>
            </div>
            <div class="quote-view-spacer d-print-none"></div>
          </template>
          <template v-else>
          <span class="my-9 quote"><!-- 13 Feb 2026 JCH: "quote" class uses serif heading style -->
            <br>
            <div class="my-0 h5 text-center">{{ carrierDisplay }}</div>
            <div class="my-0 h6 text-center">{{ long.type || '' }} Proposal</div>
            <!-- 18 Jul 2026 JCH (NC-1577 Option B): period lives in option rows (legacy), not title -->
            <div class="my-0 h6 text-center"><em>offered by Dominion Insurance Services to</em></div>
            <div class="my-0 h5 text-center">{{ policy.insured }}</div>
          </span>
          <br>
          <table class="caption quotetable" style="margin-left: 3px; text-align: right; width:100%">
            <colgroup v-if="showEstimateOnly"><!-- 13 Feb 2026 JCH: shade estimated columns for Indicate -->
              <col :span="quoteLeadingColSpan"><!-- 29 Jul 2026 JCH (NC-1618): leading cols include optional Include -->
              <col span="6" style="background-color: whitesmoke">
            </colgroup>
            <tr v-if="showEstimateOnly"><!-- 13 Feb 2026 JCH: most columns are estimated for Indicate -->
              <td :colspan="quoteLeadingColSpan"></td>
              <td colspan="6" style="background-color: whitesmoke; text-align: center">Estimated</td>
            </tr>
            <tr>
              <!-- 29 Jul 2026 JCH (NC-1618): screen-only On print — default all on; print hides col + unchecked rows -->
              <th
                v-if="showProposalInclude"
                class="proposal-include-col d-print-none"
                style="line-height: 1.1; width: 72px; text-align: center"
              >
                <!-- Same 2-line rhythm as Circle One; i sits on the "print" line (no absolute — that overlapped Circle) -->
                <span class="proposal-include-heading">
                  <span>On</span>
                  <span class="proposal-include-heading-line2">
                    printout
                    <v-tooltip bottom max-width="240">
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon
                          v-bind="attrs"
                          v-on="on"
                          x-small
                          color="secondary darken-1"
                          class="proposal-include-info"
                        >mdi-information-outline</v-icon>
                      </template>
                      <span>Checked options appear on the printed proposal. Uncheck to leave an option off the printout.</span>
                    </v-tooltip>
                  </span>
                </span>
              </th>
              <th style="line-height: 1.1; width: 36px; text-align: center" v-if="quoteTablePolicies.length > 1">Circle<br>One</th>
              <th class="date-col" style="text-align: center">Incept</th>
              <th class="date-col" style="text-align: center">Expiry</th>
              <th class="date-col" style="text-align: center">Retro</th>
              <th>Limits</th>
              <th>Deductible</th>
              <th style="width: 30px"></th><!-- 13 Feb 2026 JCH: spacer keeps estimated shading readable -->
              <th style="width: 80px" :class="showEstimateOnly ? 'estimated-col' : ''">Premium</th>
              <th :class="showEstimateOnly ? 'estimated-col' : ''">Taxes</th>
              <th :class="showEstimateOnly ? 'estimated-col' : ''">Fees</th>
              <th :class="showEstimateOnly ? 'estimated-col' : ''">Total</th>
              <th :class="showEstimateOnly ? 'estimated-col' : ''">Deposit</th>
              <th style="width: 60px" v-if="quoteTablePolicies.length <= 1"></th>
              <th style="width: 10px"></th>
              <th style="width: 0px"></th>
            </tr>
            <tr
              :key="optionPolicy.pid || `quote-row-${index}`"
              v-for="(optionPolicy, index) in quoteRowsForDisplay"
              :class="{ 'proposal-option-excluded': showProposalInclude && !isProposalOptionIncluded(optionPolicy) }"
            >
              <td v-if="showProposalInclude" class="proposal-include-col d-print-none" style="text-align: center">
                <v-simple-checkbox
                  class="proposal-include-checkbox"
                  color="secondary"
                  :ripple="false"
                  :value="isProposalOptionIncluded(optionPolicy)"
                  :aria-label="`Include option ${index + 1} on printed proposal`"
                  @input="setProposalOptionInclude(optionPolicy, $event)"
                />
              </td>
              <td style="text-align: center" v-if="quoteTablePolicies.length > 1">{{ proposalCircleLabel(optionPolicy) }}</td>
              <td class="date-col" style="text-align: center">{{ optionPolicy.incept || policy.incept }}</td>
              <td class="date-col" style="text-align: center">{{ quoteExpiryDisplay(optionPolicy) }}</td>
              <td class="date-col" style="text-align: center">{{ date(optionPolicy.retro || policy.retro) }}</td>
              <td>{{ optionPolicy.limits }}</td>
              <td>{{ optionPolicy.deduc }}</td>
              <td></td>
              <td :class="showEstimateOnly ? 'estimated-col' : ''">{{ $_curFormat(optionPolicy.premium) }}</td>
              <td :class="showEstimateOnly ? 'estimated-col' : ''">{{ $_curFormat(optionPolicy.taxes) }}</td>
              <td :class="showEstimateOnly ? 'estimated-col' : ''">{{ $_curFormat(optionPolicy.fees) }}</td>
              <td :class="showEstimateOnly ? 'estimated-col' : ''">{{ $_curFormat(optionPolicy.total) }}</td>
              <td :class="showEstimateOnly ? 'estimated-col' : ''">{{ $_curFormat(optionPolicy.down) }}</td>
              <td v-if="quoteTablePolicies.length <= 1"></td>
              <td></td>
              <td></td>
            </tr>
          </table>
          <br>
          <div class="proposal_body" v-html="policy.forms.replace(/\n/g, '<br />')" v-if="policy.forms"></div>
          <div class="proposal_body" v-html="policy.features.replace(/\n/g, '<br />')" v-if="policy.features"></div>
          <div class="proposal_body" v-html="policy.docs.replace(/\n/g, '<br />')" v-if="policy.docs"></div>
          <div class="lowLeftLabel fine_print">
            Applicant accepts the terms and conditions of insurance outlined above and requests binding of the same.
            Applicant authorizes Dominion Insurance Services ("Dominion") to arrange for financing of the remaining
            balance, if any, net of the payment tendered herewith, and to enter into a Premium Finance Agreement on
            Applicant's behalf. Applicant acknowledges that this insurance proposal is subject to change or withdrawal
            by the underwriter prior to binding. Applicant further acknowledges that Dominion will be compensated for
            the placement of this policy by way of commission and/or fee, or portion thereof. Unless otherwise stated,
            the above terms expire the earlier of 15 days from issuance or the first business day following the
            expiration of applicant's current policy. Binding is subject to receipt of all required documentation and
            payment. All fees and any minimum earned premium are fully earned upon binding. Further, Applicant
            acknowledges that all unreported claims and/or circumstances which might lead to a claim must be reported to
            Applicant's current and prospective carriers prior to expiration of Applicant's current policy of insurance
            and inception of the proposed coverage.<template v-if="doc === 'QuoteWithNcd'"> Finally, Applicant warrants that there have been no substantive
            changes to its application since
            {{policy.submitted ? `it was executed on ${date(policy.submitted)}` : 'originally submitted' }},
            except for the following:
            <div class="quote-fill-section">
              <div class="quote-fill-line"></div>
              <div class="quote-fill-line quote-fill-line-second"></div>
            </div>
            <v-checkbox class="mt-n2 quote-no-changes" label="No Changes"></v-checkbox>
            <div class="quote-print-spacer d-none d-print-block"></div>
            <div class="quote-print-spacer d-none d-print-block"></div></template>
          </div>
          <div class="quote-signature-block">
            <div class="quote-signature-row">
              <span>Signature:</span><span class="sig-line sig-line-wide"></span>
              <span>Title:</span><span class="sig-line"></span>
              <span>Date:</span><span class="sig-line"></span>
            </div>
          </div>
          <div class="quote-view-spacer d-print-none"></div>
          </template>
          </template>

          <!-- 13 Feb 2026 JCH: Request + Binder + Declarations -->
          <template v-else>
          <span class="my-3 quote">
            <div v-if="doc === 'Declarations'" class="text-center h5 mt-2 mb-0 printhead nonquote-title">DECLARATIONS</div>
            <div v-else-if="doc === 'Request'" class="text-center h5 mt-2 mb-0 printhead nonquote-title">REQUEST TO BIND INSURANCE COVERAGE</div>
            <div v-else-if="doc === 'Binder' && requestBinderStatuses.includes(policy.status)"
                 class="text-center h5 mt-2 mb-0 printhead nonquote-title">INSURANCE BINDER</div>
            <div v-else-if="doc === 'Binder' && !requestBinderStatuses.includes(policy.status)"
                 class="text-center h5 mt-2 mb-0 printhead nonquote-title">INSURANCE PROPOSAL</div>
            <div v-else class="text-center h5 mt-2 mb-0 printhead nonquote-title">INSURANCE PROPOSAL</div>
            <div class="my-0 h6 text-center">{{ long.type || '' }}</div>
            <div v-if="doc === 'Declarations'" class="my-0 h6 text-center">Effected with Certain Underwriters at Lloyd's of London</div>
            <div v-if="doc === 'Declarations'" class="my-0 h6 text-center"><b><i>Claims Made and Reported Coverage</i></b></div>
          </span>
          <br>
          <v-row class="py-0 my-n5" v-if="isBinderLikeDoc">
            <v-col cols="3"><b>Insurance Carrier:</b></v-col>
            <v-col cols="8">{{ carrierDisplay }}</v-col>
          </v-row>
          <v-row class="py-0 my-n5" v-if="doc === 'Declarations'">
            <v-col cols="3"><b>Authority Number:</b></v-col>
            <v-col cols="8">{{ policy.contract || '' }}</v-col>
          </v-row>
          <v-row class="py-0 my-n5" v-if="doc !== 'Request'">
            <v-col cols="3"><b>Policy Number:</b></v-col>
            <v-col cols="8">{{ policy.polnum }}</v-col>
          </v-row>
          <v-row class="py-0 my-n5">
            <v-col cols="3"><b><span v-if="!isBinderLikeDoc">1. </span>Named {{ isBinderLikeDoc ? 'Insured' : 'Assured' }}:</b></v-col>
            <v-col cols="8" class="mb-n12">
              {{ policy.insured }}
              <div class="mt-n1 mb-12">
                <span v-if="!!firm.address1">{{ firm.address1 + ', '}}</span>
                <span v-if="!!firm.address2">{{ firm.address2 + ', '}}</span>
                <span v-if="!!firm.city">{{ firm.city + ', '}}</span>
                {{ firm.state }} &nbsp{{ firm.zip }}
              </div>
            </v-col>
          </v-row>
          <v-row class="py-0 my-n5">
            <v-col cols="3"><b><span v-if="!isBinderLikeDoc">2. </span>Period of Insurance:</b></v-col>
            <v-col cols="8" v-if="policy.incept && policy.expiry">
              {{ date(policy.incept) }} &nbsp to &nbsp {{ date(policy.expiry) }}
              <span v-if="hasRetroValue">&nbsp;&nbsp;&nbsp; Retroactive to: {{ retroDisplay }}</span>
              <div class="fine_print">dates are 12:01 am</div>
            </v-col>
            <v-col cols="8" v-else-if="policy.incept">
              {{ date(policy.incept) }}
              <span v-if="hasRetroValue">&nbsp;&nbsp;&nbsp; Retroactive to: {{ retroDisplay }}</span>
              <div class="fine_print">dates are 12:01 am</div>
            </v-col>
            <v-col cols="8" v-else>Need Date(s)</v-col>
          </v-row>
          <v-row class="py-0 my-n5">
            <v-col cols="3"><b><span v-if="!isBinderLikeDoc">3. </span>Limits of Liabilty:</b></v-col>
            <v-col cols="8">{{ policy.limits }} Per Claim/Aggregate, Including Costs and Expenses</v-col>
          </v-row>
          <v-row class="py-0 my-n5">
            <v-col cols="3"><b><span v-if="!isBinderLikeDoc">4. </span>Deductible:</b></v-col>
            <v-col cols="8">{{ policy.deduc }} Per Claim, Including Costs and Expenses</v-col>
          </v-row>
          <v-row class="py-0 my-n5">
            <v-col cols="3"><b><span v-if="!isBinderLikeDoc">5. </span>Premium:</b></v-col>
            <v-col cols="8" v-if="policy.premium">{{ '$' + policy.premium.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$&,') }}</v-col>
          </v-row>
          <v-row class="py-0 my-n5" v-if="doc === 'Request'">
            <v-col cols="3"><b>Commission:</b></v-col>
            <v-col cols="8">{{ commissionDisplay }}</v-col>
          </v-row>
          <v-row v-if="doc === 'Declarations'" class="py-0 my-n5">
            <v-col cols="3"><b>7.	Notice of Claim:</b></v-col>
            <v-col cols="8">
              Dominion Insurance Services, Inc.<br>
              341 South Main Street, Suite 100, Alpine, Utah 84004<br>
            </v-col>
          </v-row>
          <v-row v-if="doc === 'Declarations'" class="py-0 my-n5">
            <v-col cols="3"><b>8.	Service of Suit:</b></v-col>
            <v-col cols="8">
              Wilson, Elser, Moskowitz, Edelman & Dicker LLP<br>
              150 East 42nd Street, New York, New York 10017<br>
            </v-col>
          </v-row>
          <v-row v-if="doc === 'Declarations'" class="py-0 my-n5">
            <v-col cols="3"><b>9.	Short Rate Table:</b></v-col>
            <v-col cols="8">As per attached endorsement NMA 45.</v-col>
          </v-row>
          <v-row class="py-0 my-n4">
            <v-col cols="3"><b>Prepared/Issued By:</b></v-col>
            <v-col cols="8">Dominion Insurance Services, Inc.<br>
              <v-row class="justify-start nonquote-signature-row" v-if="requestBinderStatuses.includes(policy.status)"><!-- 13 Feb 2026 JCH: print/screen signature spacing controlled in CSS -->
                <v-col cols="6">
                  <div class="underline">&nbsp;&nbsp;
                    <img src="https://in.dominioninsurance.com/images/Larry.gif" height="90">
                  </div>
                  &nbsp;&nbsp;Countersignature
                </v-col>
                <v-col cols="3">
                  <div class="underline"> &nbsp<img height="90" class="align-bottom"> {{ date(policy.incept) }}</div>
                  &nbsp;&nbsp;Date
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <br>
          <div v-if="['Binder','Request'].includes(doc) && !!policy.forms" style="font-size: .94rem" class="text-start mt-2 mb-0"
               v-html="policy.forms.replace(/\n/g, '<br />')">
          </div>
          <div v-if="['Binder','Request'].includes(doc) && !!policy.docs" style="font-size: .94rem" class="text-start mt-2 mb-0"
               v-html="policy.docs.replace(/\n/g, '<br />')">
          </div>
          <div v-if="doc === 'Declarations'">
            <v-row class="py-0 my-4" v-if="links && links.length > 0">
              <v-col cols="3"><b>Forms & Notices:</b></v-col>
              <v-col cols="8">
                <v-row v-for="link in links" :key="link.loidfid" class="my-n3">
                  <v-col>
                    <a :href="`${url}/download/${link.loidfid}`"><u>{{ link.file_description }}</u></a>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </div>
          <br>
          <br>
          <br>
          </template>
        </div>
      </v-card>

      <!--   alerts    -->
      <ErrorDialog ref="errorDialog"/>
    </div>
  </div>
</template>

<script>
import ErrorDialog from "../../ErrorDialog";
import {FirmsAPIService} from "@/servicehandlers/FirmsAPIService";
import { ListsAPIService } from '../../../servicehandlers/ListsAPIService';
import moment from 'moment';
import { PoliciesAPIService } from "@/servicehandlers/PoliciesAPIService";
import currency from 'currency.js';

const firmsAPIService = new FirmsAPIService();
const listsAPIService = new ListsAPIService();
const policiesAPIService = new PoliciesAPIService();
const COMMISSION_DECIMAL_PRECISION = 6;

export default {
  name: 'ViewPolicy',
  components: { ErrorDialog },
  props: {
    id: [String, Number],
    dialog: Boolean,
  },
  data: () => ({

    //--------- Data Variables ---------//

    doc: 'Summary',
    errors: [],
    firm: {},
    links: [],
    loading: false,
    forceAllDocsForDev: false,
    long: {},
    policies: [],
    summaryPolicies: [],
    policy: {},
    // 29 Jul 2026 JCH (NC-1618): pid -> include on printed proposal; missing key = included
    proposalIncludeByPid: {},
    // 30 Jul 2026 JCH (NC-1618): drop On-printout column from DOM while printing so Indicate colspan stays correct
    isPrinting: false,
    url: process.env.VUE_APP_UW_URL,
  }),

  created: async function() {
    this.initDevAllDocsFromUrlOrStorage();
    await this.getPolicy();
    this.getPolicies();
  },

  watch: {
    id() {
      this.proposalIncludeByPid = {};
    },
    quoteTablePolicies: {
      immediate: true,
      handler(rows) {
        this.syncProposalIncludeDefaults(rows);
      },
    },
  },

  computed: {
    showNoEligibleDocMessage() {
      if (this.showAllDocsForDev) return false;
      return !!(this.policy && this.policy.pid)
        && !this.showSummaryTab
        && !this.showIndicateTab
        && !this.showQuoteTab
        && !this.showRequestTab
        && !this.showBinderTab
        && !this.showDeclarationsTab;
    },
    isSummaryDoc() { return this.doc === 'Summary'; },
    isQuoteLikeDoc() {
      return this.doc === 'Summary' || this.doc === 'Quote' || this.doc === 'QuoteWithNcd' || this.doc === 'Indicate';
    },
    isBinderLikeDoc() { return this.doc === 'Binder' || this.doc === 'Request'; },
    requestBinderStatuses() { return ['Book', 'Past', 'Lost', 'dncLost', 'Tail']; },
    hasContractNumber() { return !!(this.policy && this.policy.contract && this.policy.contract.toString().trim()); },
    policyStatusNormalized() { return (this.policy.status || '').toString().trim().toLowerCase(); },
    isQuotePolicy() { return this.policyStatusNormalized === 'quote'; },
    isIndicatePolicy() { return this.policyStatusNormalized === 'indicate'; },
    showEstimateOnly() {
      return this.doc === 'Indicate'; // 13 Feb 2026 JCH: Keep estimate styling tied to selected tab, not status
    },
    hasRetroValue() {
      return this.policy.retro !== null && this.policy.retro !== undefined && this.policy.retro.toString().trim() !== '';
    },
    retroDisplay() { return this.hasRetroValue ? this.date(this.policy.retro) : ''; },
    isDevMode() { return process.env.NODE_ENV !== 'production'; },
    showAllDocsForDev() { return this.isDevMode && this.forceAllDocsForDev; },
    showSummaryTab() { return this.isIndicatePolicy || this.isQuotePolicy || this.showAllDocsForDev; },
    showQuoteTab() { return this.isQuotePolicy || this.showAllDocsForDev; },
    showIndicateTab() { return this.isIndicatePolicy || this.showAllDocsForDev; },
    showRequestTab() { return this.requestBinderStatuses.includes(this.policy.status) || this.showAllDocsForDev; },
    showBinderTab() { return this.requestBinderStatuses.includes(this.policy.status) || this.showAllDocsForDev; },
    showDeclarationsTab() { return this.hasContractNumber || this.showAllDocsForDev; },
    carrierDisplay() { return this.long.carrier || this.policy.carrier || ''; }, // 13 Feb 2026 JCH: Prefer Lists long carrier, fallback to policy short text
    summaryTitle() {
      const typeName = (this.long.type || this.policy.type || '').toString().trim();
      return typeName ? `${typeName} Coverage Options` : 'Coverage Options';
    },
    summaryFirmName() { return (this.policy.insured || '').toString().trim(); },
    currentPolicyRows() { return this.policy && this.policy.pid ? [this.policy] : []; },
    quoteTablePolicies() {
      // 13 Feb 2026 JCH: Render-safe source for quote rows (prevents blank table when policies array misses).
      return Array.isArray(this.policies) && this.policies.length ? this.policies : this.currentPolicyRows;
    },
    // 29 Jul 2026 JCH (NC-1618): On-printout column when multi-option; hidden while printing (colspan + print layout)
    showProposalInclude() {
      return !this.isPrinting && this.quoteTablePolicies.length > 1;
    },
    quoteLeadingColSpan() {
      // Before Premium: optional On-printout + optional Circle One + Incept/Expiry/Retro + Limits + Deductible + spacer
      let n = 6;
      if (this.quoteTablePolicies.length > 1) n += 1;
      if (this.showProposalInclude) n += 1;
      return n;
    },
    includedQuoteTablePolicies() {
      if (this.quoteTablePolicies.length <= 1) return this.quoteTablePolicies;
      return this.quoteTablePolicies.filter((row) => this.isProposalOptionIncluded(row));
    },
    // 30 Jul 2026 JCH (NC-1618): during print, omit unchecked rows entirely (not only CSS hide)
    quoteRowsForDisplay() {
      if (!this.isPrinting || this.quoteTablePolicies.length <= 1) return this.quoteTablePolicies;
      return this.includedQuoteTablePolicies;
    },
    summaryTablePolicies() {
      // 23 Feb 2026 JCH: Summary rows use type + inception-month grouping (carrier may differ).
      return Array.isArray(this.summaryPolicies) && this.summaryPolicies.length ? this.summaryPolicies : this.currentPolicyRows;
    },
    commissionDisplay() {
      const premium = Number(this.policy.premium || 0);
      // 05 May 2026 JCH: Calculate request commission on the frontend from existing split fields using backend-matching 6-decimal precision.
      const totalComDecimal = ['procom', 'spncom', 'srccom', 'subcom']
        .reduce((total, field) => total.add(Number(this.policy[field] || 0)), currency(0, { precision: COMMISSION_DECIMAL_PRECISION })).value;
      const commissionPercent = currency(totalComDecimal, { precision: COMMISSION_DECIMAL_PRECISION }).multiply(100).value;
      const commissionNum = currency(totalComDecimal, { precision: COMMISSION_DECIMAL_PRECISION }).multiply(premium).value;
      const amount = currency(commissionNum).format();
      const percent = currency(commissionPercent, { symbol: '', precision: 2 }).format();
      return `${amount} (${percent}%)`;
    },
  },

  methods: {
    isQuoteOrIndicateStatus(status) {// 15 Jun 2026 JCH (NC-1609): Summary/Quote option rows — Quote or Indicate only
      const s = (status || '').toString().trim().toLowerCase();
      return s === 'quote' || s === 'indicate';
    },
    normalizeSummaryStatus(status, fallbackStatus = 'Quote') {
      const toSummaryStatus = (value) => ({ quote: 'Quote', indicate: 'Indicate' }[(value || '').toString().trim().toLowerCase()] || '');
      return toSummaryStatus(status) || toSummaryStatus(fallbackStatus) || 'Quote';
    },
    initDevAllDocsFromUrlOrStorage() {
      if (!this.isDevMode) return;
      const queryValue = this.$route && this.$route.query ? this.$route.query.allDocs : null;
      this.forceAllDocsForDev = queryValue === '1' || queryValue === 'true'; // 13 Feb 2026 JCH: URL-only allDocs toggle keeps dev UI hidden
    },
    date(date) {
      // Keep backend dates as-is; preserve retro FPA display label.
      return ['fpa', 'full'].includes((date || '').toString().trim().toLowerCase()) ? 'Full Prior Acts' : date;
    },
    getLongs() {
      for (let field of ['carrier', 'type']) {
        let list = field === 'type' ? 'ptype' : field;
        listsAPIService.getList(list, '0', false, false, 'ASC', 'sort', true, this.$router).then((listData) => {
          const strict = listData.find((o) => o.text === this.policy[field]); // 13 Feb 2026 JCH: Keep 1224 exact short->long lookup first
          if (strict && strict.long) {
            this.$set(this.long, field, strict.long); // 13 Feb 2026 JCH: Use reactive set so long value reliably repaints
            return;
          }
          const normalize = (value) => (value || '').toString().trim().toLowerCase();
          const policyValue = normalize(this.policy[field]);
          const match = listData.find((o) => normalize(o.text) === policyValue || normalize(o.long) === policyValue);
          if (match && match.long) {
            this.$set(this.long, field, match.long); // 13 Feb 2026 JCH: Normalized fallback catches spacing/case drift
            return;
          }
          // 13 Feb 2026 JCH: fallback to cached lists if API rows do not match.
          const cached = this.$_lists && Array.isArray(this.$_lists[list]) ? this.$_lists[list] : [];
          const fromCache = cached.find((o) => normalize(o.text) === policyValue || normalize(o.long) === policyValue);
          this.$set(this.long, field, fromCache && fromCache.long ? fromCache.long : '');
        }).catch(() => {
          this.$set(this.long, field, '');
        });
      }
    },
    getPolicies() {// 13 Feb 2026 JCH: match firm policies by type/carrier/incept/expiry/retro
      if (!this.policy || !this.policy.fid) return;
      const m = this.policy;// 13 Feb 2026 JCH: main policy baseline for matching
      firmsAPIService.getFirmPolicies(this.policy.fid, this.$router).then((policies) => {
        this.policies = [];
        this.summaryPolicies = [];
        const fallbackSummaryStatus = this.normalizeSummaryStatus(m.status, 'Quote');
        const policyRows = Array.isArray(policies) ? policies : [];
        const addUniqueByPid = (target, row, mapRow = (value) => value) => {
          if (!row) return;
          const mapped = mapRow(row);
          const exists = target.some((existing) => Number(existing.pid) === Number(mapped.pid));
          if (!exists) target.push(mapped);
        };
        const addUniquePolicy = (row) => {
          if (!this.isQuoteOrIndicateStatus(row && row.status)) return;
          addUniqueByPid(this.policies, row);
        };
        const addUniqueSummaryPolicy = (row) => {
          if (!this.isQuoteOrIndicateStatus(row && row.status)) return;
          addUniqueByPid(this.summaryPolicies, row, (value) => ({
            ...value,
            status: this.normalizeSummaryStatus(value.status, fallbackSummaryStatus)
          }));
        };
        addUniquePolicy(this.policy);// 13 Feb 2026 JCH: Always include current policy row in quote table
        addUniqueSummaryPolicy(this.policy);// 23 Feb 2026 JCH: Always include current policy in summary table
        const normalizeText = (value) => (value || '').toString().trim().toLowerCase();
        const parseDate = (value) => moment(value, ['M-D-YYYY', 'MM-DD-YYYY', 'YYYY-MM-DD'], true);
        const normalizeDate = (value) => {
          const parsed = parseDate(value);
          return parsed.isValid() ? parsed.format('YYYY-MM-DD') : normalizeText(value);
        };
        const normalizeMonth = (value) => {
          const parsed = parseDate(value);
          return parsed.isValid() ? parsed.format('YYYY-MM') : '';
        };
        const mainType = normalizeText(m.type);
        const mainCarrier = normalizeText(m.carrier);
        const mainIncept = normalizeDate(m.incept);
        const mainExpiry = normalizeDate(m.expiry);
        const mainRetro = normalizeDate(m.retro);
        let strictCount = 0;
        const mainInceptMonth = normalizeMonth(m.incept);

        // 23 Feb 2026 JCH: Summary grouping rule = same type + same inception month; carrier can differ.
        for (let p of policyRows) {
          if (normalizeText(p.type) === mainType && normalizeMonth(p.incept) === mainInceptMonth) {
            addUniqueSummaryPolicy(p);
          }
        }

        // 18 Jul 2026 JCH (NC-1577 Option B): grouped options (tails) share grpnum+prid; ungrouped keep same-dates match.
        const mainGrpnum = Number(m.grpnum || 0);
        const mainPrid = m.prid;
        const mainPridNum = Number(mainPrid);
        if (mainGrpnum !== 0 && mainPrid != null && mainPrid !== '' && Number.isFinite(mainPridNum)) {
          for (let p of policyRows) {
            // 20 Jul 2026 JCH (NC-1577): coerce prid — API may mix string/number ids
            if (Number(p.grpnum || 0) === mainGrpnum && Number(p.prid) === mainPridNum) addUniquePolicy(p);
          }
        } else {
          for (let p of policyRows) {// 13 Feb 2026 JCH: strict pass for quote/indicate options
            if (p.type === m.type && p.carrier === m.carrier && p.incept === m.incept && p.expiry === m.expiry
              && p.retro === m.retro) {
              addUniquePolicy(p);
              strictCount += 1;
            }
          }
          if (strictCount === 0) { // 13 Feb 2026 JCH: If strict 1224 returns none, run normalized fallback so 1528 is not worse
            for (let p of policyRows) {
              if (normalizeText(p.type) === mainType
                && normalizeText(p.carrier) === mainCarrier
                && normalizeDate(p.incept) === mainIncept
                && normalizeDate(p.expiry) === mainExpiry
                && normalizeDate(p.retro) === mainRetro) addUniquePolicy(p);
            }
          }
        }
        this.policies.sort(function(a, b) { return a.premium - b.premium });// 13 Feb 2026 JCH: low-to-high premium order
        this.summaryPolicies.sort(function(a, b) { return Number(a.total || 0) - Number(b.total || 0) });
      }).catch(() => {
        const eligible = this.currentPolicyRows.filter((row) => this.isQuoteOrIndicateStatus(row.status));
        this.policies = eligible;
        this.summaryPolicies = eligible.map((row) => ({ ...row, status: this.normalizeSummaryStatus(row.status, 'Quote') }));
      });
    },
    syncDocSelection() {
      const firstVisible =
        (this.showSummaryTab && 'Summary')
        || (this.showIndicateTab && 'Indicate')
        || (this.showQuoteTab && 'QuoteWithNcd')
        || (this.showRequestTab && 'Request')
        || (this.showBinderTab && 'Binder')
        || (this.showDeclarationsTab && 'Declarations')
        || 'QuoteWithNcd';
      const visibleByDoc = {
        Summary: this.showSummaryTab,
        Quote: this.showQuoteTab,
        QuoteWithNcd: this.showQuoteTab,
        Indicate: this.showIndicateTab,
        Request: this.showRequestTab,
        Binder: this.showBinderTab,
        Declarations: this.showDeclarationsTab,
      };
      if (visibleByDoc[this.doc] === false) this.doc = firstVisible;
    },
    isUnlimitedExpiry(expiryRaw) {
      return /^unlimited$/i.test((expiryRaw || '').toString().trim());
    },
    quoteExpiryDisplay(optionPolicy) {
      // 18 Jul 2026 JCH (NC-1577): Quote/Indicate/Summary Expiry column — date, or none for Unlimited.
      const expiryRaw = optionPolicy && optionPolicy.expiry ? optionPolicy.expiry : this.policy.expiry;
      if (this.isUnlimitedExpiry(expiryRaw)) return 'none';
      return this.date(expiryRaw);
    },
    optionIncludeKey(optionPolicy) {
      if (optionPolicy && optionPolicy.pid != null && optionPolicy.pid !== '') return String(optionPolicy.pid);
      return '';
    },
    syncProposalIncludeDefaults(rows) {
      const list = Array.isArray(rows) ? rows : [];
      const next = { ...this.proposalIncludeByPid };
      for (const row of list) {
        const key = this.optionIncludeKey(row);
        if (key && next[key] === undefined) next[key] = true;
      }
      this.proposalIncludeByPid = next;
    },
    isProposalOptionIncluded(optionPolicy) {
      const key = this.optionIncludeKey(optionPolicy);
      if (!key) return true;
      return this.proposalIncludeByPid[key] !== false;
    },
    setProposalOptionInclude(optionPolicy, included) {
      const key = this.optionIncludeKey(optionPolicy);
      if (!key) return;
      // Keep at least one option on the printed proposal
      if (!included && this.isProposalOptionIncluded(optionPolicy)
        && this.includedQuoteTablePolicies.length <= 1) return;
      this.$set(this.proposalIncludeByPid, key, !!included);
    },
    proposalCircleLabel(optionPolicy) {
      // 29 Jul 2026 JCH (NC-1618): Circle One numbers only options that will print (also while isPrinting)
      const multi = this.quoteTablePolicies.length > 1;
      if (multi && !this.isProposalOptionIncluded(optionPolicy)) return '—';
      let n = 0;
      for (const row of this.quoteTablePolicies) {
        if (multi && !this.isProposalOptionIncluded(row)) continue;
        n += 1;
        if (Number(row.pid) === Number(optionPolicy.pid)) return n;
      }
      return n || '';
    },

    getPolicy: async function() {
      this.loading = true;
      try {
        this.policy = await policiesAPIService.getPolicy(this.id, this.$router);
        if (this.isDevMode) console.debug('[ViewPolicy] contract', { pid: this.policy.pid, contract: this.policy.contract });
        this.syncDocSelection();
        this.getLongs();
        let firm = await firmsAPIService.getSingleFirm(this.policy.fid, this.$router);
        this.firm = firm;
        if (this.policy.insured) document.title = this.policy.insured;
        this.links = await policiesAPIService.getPolicyFiles(this.policy.pid, this.$router);
        let titles = [// 13 Feb 2026 JCH: bold known section titles in forms/features/docs
          { name: 'FORM \&amp; ENDORSEMENTS',       field: 'forms' },// 13 Feb 2026 JCH: title variants from policy payload
          { name: 'FORMS \&amp; ENDORSEMENTS',      field: 'forms' },
          { name: 'FORM & ENDORSEMENTS',            field: 'forms' },
          { name: 'FORMS & ENDORSEMENTS',           field: 'forms' },
          { name: 'SELECTED POLICY FEATURES',       field: 'features' },
          { name: 'QUOTE TERMS EXPIRE:',            field: 'docs' },
          { name: 'ITEMS REQUIRED TO BIND COVERAGE',field: 'docs' }]
        for (let t of titles) if (this.policy[t.field]) this.policy[t.field] = this.policy[t.field].replace(t.name, '<b>' + t.name + '</b>');
        if (this.policy.docs) this.policy.docs = this.policy.docs.replace(/�/g, "'");// 13 Feb 2026 JCH: normalize bad apostrophe encoding
        this.loading = false;
      } catch (e) {
        this.$refs.errorDialog.showError({
          errorMessage: "Failed to get Policy.",
          forDevelopers: e
        })
      }
    },

    printDiv() {
      // 30 Jul 2026 JCH (NC-1618): remove On-printout col + excluded rows for print, then restore after dialog
      this.isPrinting = true;
      this.$nextTick(() => {
        const restore = () => {
          this.isPrinting = false;
          window.removeEventListener('afterprint', restore);
        };
        window.addEventListener('afterprint', restore);
        window.print();
      });
    },
  },
};
</script>

<style>
@media print
{
  #printableArea {
    width: 100% !important;
    max-width: none !important;
    margin: 0 !important;
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
  body * { visibility: hidden }
  .div2 * { visibility: visible }
  .div2 { position: absolute; left: 0px; font-size: 23px; margin: -48px 0 0 !important; width: 100% !important }
  .quote-shell { margin: -70px 0 0 !important } /* 13 Feb 2026 JCH: align quote/indicate print header */
  .non-quote-shell { font-size: 16px !important } /* 13 Feb 2026 JCH: non-quote print body reduced */
  .quotetable, .quotetable * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
  .h5 { font-size: 26px }
  .h6 { font-size: 20px }
  .printhead { font-size: 22px } /* 13 Feb 2026 JCH: non-quote print title reduced */
  .nonquote-signature-row { margin-top: 50px !important; }
  .quote-print-spacer { height: 16px; }
  .quote-fill-section { margin-top: 34px; }
  .quote-signature-row { font-size: 15px; }
  .quote-signature-block {
    margin-top: 44px;
    break-inside: avoid;
    page-break-inside: avoid; /* 13 Feb 2026 JCH: keep quote signature block together on one page */
  }
  .quote-no-changes .v-label { font-size: 13px !important; }
  .summarytable col:nth-child(1) { width: 38px !important; }
  .summarytable col:nth-child(2) { width: 18% !important; }
  .summarytable col:nth-child(6) { width: 16% !important; }
  .summarytable col:nth-child(7) { width: 14% !important; }
  .summarytable col:nth-child(8) { width: 17% !important; }
  .summarytable col:nth-child(9) { width: 64px !important; }
  .summarytable th:first-child,
  .summarytable td:first-child { padding-left: 0 !important; padding-right: 2px !important; }
  .summarytable th:last-child,
  .summarytable td:last-child { padding-left: 2px !important; padding-right: 1px !important; }
}
@page { margin: .45in .18in .5in .18in !important }
.quote { font-family: Playfair, "Times New Roman", serif }
.proposal_body { font-size: 11pt; color: #222; font-weight: normal; line-height: 1.35; }
.proposal_body b { font-weight: 600; }
.fine_print { font-size: 9pt; color: #222; font-weight: normal; line-height: 1.35; }
.quote-fill-line {
  width: 100%;
  border-bottom: 2px solid #000; /* 13 Feb 2026 JCH: stronger print/write-in visibility */
  margin: 14px 0;
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}
.quote-fill-line-second { margin-top: 34px; }
.quote-signature-row {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  white-space: nowrap;
}
.sig-line {
  display: inline-block;
  width: 160px;
  border-bottom: 2px solid #000;
  margin-bottom: 2px;
  -webkit-print-color-adjust: exact !important;
  print-color-adjust: exact !important;
}
.sig-line-wide { width: 290px; }
.estimated-col {
  background-color: whitesmoke !important; /* 13 Feb 2026 JCH: Estimated shading in screen + print */
}
.summary-header {
  display: block;
  max-width: 760px; /* Keep long title/farm name from stretching edge-to-edge */
  margin: 0 auto;
  line-height: 1.3;
}
.summary-header .h5,
.summary-header .h6 {
  font-size: 1.1rem;
}
.summary-header .h4 {
  font-weight: 500;
}
.summarytable {
  table-layout: fixed;
}
/* 18 Jul 2026 JCH (NC-1577): keep Incept/Expiry/Retro dates on one line */
.quotetable .date-col {
  white-space: nowrap;
  word-break: keep-all;
}
/* 29 Jul 2026 JCH (NC-1618): On-print checkbox — screen only; excluded rows omit from print */
.proposal-include-checkbox {
  margin: 0 auto;
  transform: scale(0.92);
}
.proposal-include-heading {
  display: inline-flex;
  flex-direction: column;
  align-items: center;
  line-height: 1.1;
}
.proposal-include-heading-line2 {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 1px;
  white-space: nowrap;
}
.proposal-include-info {
  cursor: help;
  flex: 0 0 auto;
}
.proposal-option-excluded td {
  color: #888;
}
@media print {
  .proposal-include-col,
  .proposal-option-excluded {
    display: none !important;
  }
}
.summarytable th,
.summarytable td {
  color: #222;
  padding: 2px 5px;
  line-height: 1.05;
}
.summarytable .date-col {
  white-space: nowrap;
  word-break: keep-all;
}
.summarytable th {
  font-weight: 600;
  text-align: center !important;
}
.summarytable td {
  font-weight: 500;
}
.summary-check-box {
  display: inline-block;
  width: 13px;
  height: 13px;
  border: 1px solid #777;
}
.lowLeftLabel .v-input--selection-controls .v-input__slot > .v-label, .v-input--selection-controls .v-radio > .v-label {
  margin-top: 3px;
  margin-left: -4px;
}
@media screen {
  .viewpolicy-tabs { margin-bottom: 4px; }
  .quote-signature-block { margin-top: 30px; }
  .quote-view-spacer { height: 54px; }
  .viewpolicy-tabs .v-btn { margin-right: 6px !important; }
  .viewpolicy-tabs .v-btn:last-child { margin-right: 0 !important; }
  .nonquote-screen-pad { padding-top: 22px; }
  .nonquote-signature-row {
    margin-top: 20px; /* 13 Feb 2026 JCH: screen headroom above non-quote signature row */
  }
  .quote-fill-section {
    margin-top: 54px; /* 13 Feb 2026 JCH: screen headroom for write-in lines */
  }
  .quote-signature-row {
    font-size: 16px;
  }
}
</style>


